import { useState, useEffect, useCallback } from "react";

import { loginController } from "pages/login/LoginPage";
import { signupController } from "pages/login/SignUpPage";
import { forgotPasswordController } from "pages/login/ForgotPasswordPage";

/**
 * Client-side rate limiter: allows 6 attempts per 60 seconds.
 * Resets on page unmount. The backend has its own rate limiting
 * (express-rate-limit, 15/min/IP) as the real safeguard.
 */
export const useRateLimiter = () => {
  const [attempts, setAttempts] = useState([]);

  const handleCheckLimitEvent = useCallback(() => {
    const now = Date.now();
    // Keep only attempts within the last 60 seconds
    setAttempts((prev) => {
      const recent = prev.filter((t) => now - t < 60000);
      const updated = [...recent, now];

      if (updated.length > 6) {
        // Too many attempts — abort the in-flight request
        if (loginController) {
          loginController.abort("too many frequent attempts");
        } else if (signupController) {
          signupController.abort("too many frequent attempts");
        } else if (forgotPasswordController) {
          forgotPasswordController.abort("too many frequent attempts");
        }
      }

      return updated;
    });
  }, []);

  useEffect(() => {
    window.addEventListener("checkLimit", handleCheckLimitEvent);
    return () => {
      window.removeEventListener("checkLimit", handleCheckLimitEvent);
    };
  }, [handleCheckLimitEvent]);
};
